// extracted by mini-css-extract-plugin
export default {"container":"MedicalCenterRefinements_container__OcCni","aside":"MedicalCenterRefinements_aside__cEI0J","title":"MedicalCenterRefinements_title__2bIIw"};